import React, { Component } from 'react';
import { Row, Col, Select, Form, Modal, InputNumber, Input } from 'antd';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
const { Option } = Select;
const nestedKeys = ['account'];

@withRouter
@inject('store')
@observer
class SessionFormComponent extends Component {
    componentDidMount() {
        this.props.store.strategyStore.getOdysseyStrategies();
    }

    async handleSubmit() {
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                const longStrat = this.props.store.strategyStore.odysseyLong.find(
                    s => s._id === values.long_strategy
                );
                const shortStrat = this.props.store.strategyStore.odysseyShort.find(
                    s => s._id === values.short_strategy
                );
                values.status = 'PAUSED';
                values.long_strategy_name = longStrat ? longStrat.name : 'None';
                values.short_strategy_name = shortStrat ? shortStrat.name : 'None';

                let data = {};
                Object.keys(values).forEach(key => {
                    let copied = false;
                    nestedKeys.forEach(whitelisted => {
                        if (key.indexOf(whitelisted) === 0) {
                            data[whitelisted] = data[whitelisted] || {};
                            data[whitelisted][key.replace(`${whitelisted}_`, '')] = values[key];
                            copied = true;
                        }
                    });
                    if (!copied && values[key] != null) {
                        data[key] = values[key];
                    }
                });

                data.trader = this.props.store.userStore.currentUser.name;
                await this.props.store.odysseyBotStore.createTradingSession(
                    this.props.match.params.id,
                    data
                );
                this.props.onCancel();
            }
        });
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const accountType = getFieldValue('account_type');
        const accountSize = getFieldValue(`account_size`);
        const accountRisk = getFieldValue(`account_risk`);
        const tradingPair = getFieldValue('trading_pair');
        const riskInAsset = ((accountSize / 100) * accountRisk).toFixed(8);

        return (
            <Modal
                title="Create Trading Session"
                visible={this.props.visible}
                onCancel={this.props.onCancel.bind(this)}
                onOk={this.handleSubmit.bind(this)}
            >
                <Row gutter={24}>
                    <Col md={24}>
                        <Form.Item label={'Session Name'}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label={'Trading Pair'}>
                            {getFieldDecorator('trading_pair', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 'BTCUSD'
                            })(
                                <Select style={{ width: '100%' }}>
                                    <Option value={'BTCUSD'}>BTC</Option>
                                    <Option value={'ETHUSD'}>ETH</Option>
                                    <Option value={'XRPUSD'}>XRP</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Type">
                            {getFieldDecorator(`account_type`, {
                                initialValue: 'managed'
                            })(
                                <Select style={{ width: '100%' }}>
                                    <Option value="managed">Managed Risk</Option>
                                    <Option value="custom">Custom</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ display: accountType === 'managed' ? 'block' : 'none' }}>
                        <Form.Item label={`Account Size: ${tradingPair}`}>
                            {getFieldDecorator(`account_size`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.005
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ display: accountType === 'managed' ? 'block' : 'none' }}>
                        <Form.Item label="Risk %" extra={`Risk ${riskInAsset} ${tradingPair} `}>
                            {getFieldDecorator(`account_risk`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 3
                            })(
                                <InputNumber
                                    formatter={value =>
                                        `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                    parser={value => value.replace(/%\s?|(,*)/g, '')}
                                />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ display: accountType === 'custom' ? 'block' : 'none' }}>
                        <Form.Item label="Position Size ">
                            {getFieldDecorator(`account_position_size`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 10
                            })(
                                <InputNumber
                                    formatter={value =>
                                        `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ display: accountType === 'custom' ? 'block' : 'none' }}>
                        <Form.Item label="Leverage ">
                            {getFieldDecorator(`account_position_leverage`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 1
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Long Strategy">
                            {getFieldDecorator('long_strategy', {
                                initialValue: ''
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    optionFilterProp="name"
                                >
                                    <Option value="">None</Option>
                                    {this.props.store.strategyStore.odysseyLong
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s._id} key={s._id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Short Strategy">
                            {getFieldDecorator('short_strategy', {
                                initialValue: ''
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    optionFilterProp="name"
                                >
                                    <Option value="">None</Option>
                                    {this.props.store.strategyStore.odysseyShort
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s._id} key={s._id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Modal>
        );
    }
}

const mapProps = (prefix, data, acc) => {
    if (!data) return;

    Object.keys(data).forEach(key => {
        acc[`${prefix}_${key}`] = Form.createFormField({ value: data[key] });
    });
};

export const SessionForm = Form.create({
    mapPropsToFields: props => {
        const data = {};

        Object.keys(props.data || {}).forEach(key => {
            let copied = false;
            nestedKeys.forEach(whitelisted => {
                if (key.indexOf(whitelisted) === 0 && key.indexOf('indicators') === -1) {
                    mapProps(whitelisted, props.data[whitelisted], data);
                    copied = true;
                    return;
                }
            });

            if (!copied) data[key] = Form.createFormField({ value: props.data[key] });
        });
        return data;
    }
})(SessionFormComponent);



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SessionsView/SessionForm.js